<template>
  <div class="forbidden-page-wrapper">
    <section class="forbidden-panel" aria-labelledby="forbidden-title">
      <div class="forbidden-icon">
        <i class="fa-solid fa-ban"></i>
      </div>
      <p class="forbidden-code">403</p>
      <h1 id="forbidden-title" class="forbidden-title">Access denied</h1>
      <p class="forbidden-message">
        You do not have permission to access this resource.
      </p>
      <router-link to="/login" class="login-button">Go to login</router-link>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ForbiddenPage'
};
</script>

<style scoped>
.forbidden-page-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: #f8fafc;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.forbidden-panel {
  width: 100%;
  max-width: 440px;
  padding: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);
  text-align: center;
}

.forbidden-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fee2e2;
  color: #dc2626;
  font-size: 24px;
}

.forbidden-code {
  margin: 0 0 8px;
  color: #dc2626;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
}

.forbidden-title {
  margin: 0 0 10px;
  color: #0f172a;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0;
}

.forbidden-message {
  margin: 0 0 28px;
  color: #475569;
  font-size: 15px;
  line-height: 1.6;
}

.login-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 22px;
  border-radius: 8px;
  background: #4f46e5;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  transition: background 0.2s ease, transform 0.2s ease;
}

.login-button:hover {
  background: #4338ca;
  transform: translateY(-1px);
}

:global(.dark-mode) .forbidden-page-wrapper {
  background: #0f172a;
}

:global(.dark-mode) .forbidden-panel {
  background: #111827;
  border-color: #334155;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.28);
}

:global(.dark-mode) .forbidden-title {
  color: #f8fafc;
}

:global(.dark-mode) .forbidden-message {
  color: #cbd5e1;
}
</style>
